export default __webpack_public_path__ + "media/images/nippii-icon-1920x1920-transparent-92f6f385.png";